/* Maison Sabelle collection page: filter drawer, sort, and filtering/paging without a reload (the section is
   re-rendered by Shopify's section rendering and swapped in). Card add-to-bag comes from sabelle-quick-add.js. */
import './sabelle-quick-add.js';

function init(root) {
  if (root.dataset.sclReady) return;
  root.dataset.sclReady = '1';
  const sectionId = root.closest('.shopify-section')?.id.replace('shopify-section-', '') || root.dataset.section;
  let controller = null;

  const body = () => root.querySelector('[data-scl-body]');
  const drawer = () => root.querySelector('[data-drawer]');
  const form = () => root.querySelector('[data-filter-form]');

  const urlFromForm = () => {
    const f = form();
    const params = new URLSearchParams();
    new FormData(f).forEach((v, k) => { if (String(v).trim() !== '') params.append(k, v); });
    const sort = root.querySelector('[data-sort]');
    if (sort) params.set('sort_by', sort.value);
    return `${f.getAttribute('action')}?${params.toString()}`;
  };

  const fetchSection = async (url) => {
    controller?.abort();
    controller = new AbortController();
    const u = new URL(url, location.origin);
    u.searchParams.set('section_id', sectionId);
    const html = await fetch(u, { signal: controller.signal }).then((r) => r.text());
    return new DOMParser().parseFromString(html, 'text/html');
  };

  /* Swap in the new grid, toolbar and drawer. The drawer stays open if it was. */
  const render = async (url, { push = true, keepDrawer = false } = {}) => {
    const current = body();
    current.classList.add('is-loading');
    try {
      const doc = await fetchSection(url);
      const next = doc.querySelector('[data-scl-body]');
      if (!next) { location.href = url; return; }
      const wasOpen = drawer()?.open;
      if (wasOpen && !keepDrawer) drawer().close();
      current.replaceWith(next);
      if (wasOpen && keepDrawer) drawer()?.showModal();
      bind();
      if (push) history.pushState({ scl: true }, '', url);
    } catch (err) {
      if (err.name !== 'AbortError') location.href = url;
    }
  };

  /* While the drawer is open, keep its "Show n pieces" honest without touching the grid. */
  let previewTimer;
  const preview = () => {
    clearTimeout(previewTimer);
    previewTimer = setTimeout(async () => {
      try {
        const doc = await fetchSection(urlFromForm());
        const n = doc.querySelector('[data-apply-count]')?.textContent;
        const out = root.querySelector('[data-apply-count]');
        if (n && out) out.textContent = n;
      } catch (err) { /* ignore */ }
    }, 250);
  };

  function bind() {
    const d = drawer();
    const f = form();
    root.querySelector('[data-filter-open]')?.addEventListener('click', () => d?.showModal());
    d?.querySelector('[data-filter-close]')?.addEventListener('click', () => d.close());
    d?.addEventListener('click', (e) => { if (e.target === d) d.close(); });
    f?.addEventListener('change', preview);
    f?.addEventListener('input', (e) => { if (e.target.type === 'number') preview(); });
    f?.addEventListener('submit', (e) => { e.preventDefault(); render(urlFromForm()); });
    root.querySelector('[data-sort]')?.addEventListener('change', () => render(urlFromForm()));
    root.querySelectorAll('[data-scl-link]').forEach((a) => a.addEventListener('click', (e) => {
      e.preventDefault();
      render(a.href);
      if (a.closest('.scl-pages')) root.querySelector('.scl-bar')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }));
  }

  bind();
  addEventListener('popstate', () => render(location.href, { push: false }));
}

const boot = () => document.querySelectorAll('[data-scl]').forEach(init);
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
else boot();
document.addEventListener('shopify:section:load', boot);
